import AnnouncementBar from '../home/components/AnnouncementBar';
import Navbar from '../home/components/Navbar';
import FooterSection from '../home/components/FooterSection';
import SEOHead from '../../components/feature/SEOHead';
import { SITE_URL } from '../../utils/seo';

const hciShortcomings = [
  'Harici Depolamayı Desteklemez',
  'Gerçek Anlamda Yakınsak Değil — Aynı Üç Katmanlı Karmaşıklık',
  'Kuruluşlar İçin Ölçeklenemez — ROBO İçin Küçük Ölçeklenemez',
  'Kaynakları Bağımsız Olarak Ölçeklendiremez',
  'Satın Alması ve Yükseltmesi Pahalı',
];

const uciAdvantages = [
  { icon: 'ri-merge-cells-horizontal', title: 'Her Şeyi Birleştirin', desc: 'Tek birleşik kaynak havuzundan hızlı sağlama.' },
  { icon: 'ri-server-line', title: 'Mevcut Donanımı Kullanın', desc: 'Mevcut sunucu ve depolamanızı kullanarak maliyetleri düşürün.' },
  { icon: 'ri-arrow-down-s-line', title: 'Küçük Başlayın — Büyük Ölçeklendirin', desc: 'Uzak ofisler, orta boy ve kurumsal kullanım için idealdir.' },
  { icon: 'ri-expand-left-right-line', title: 'Bağımsız', desc: 'Depolama ve hesaplama kaynaklarını ihtiyaca göre ölçeklendirin.' },
  { icon: 'ri-money-dollar-circle-line', title: 'BT Harcamalarını Dramatik Azaltın', desc: 'Sunucu başına lisanslama. Çekirdekleri saymayı bırakın.' },
];

const comparisonRows = [
  { feature: 'Yakınsama Türü ve Derinliği', verge: 'Entegre Tek Platform', nutanix: 'Çoklu destek katmanları — vCenter, ESXi, AOS, NSX, vCD...', vmware: 'Çoklu destek katmanları — vCenter, ESXi, vSAN...' },
  { feature: 'Hiper Yönetici', verge: 'Optimize Edilmiş KVM/QEMU', nutanix: 'ESXi / AHV', vmware: 'ESXi' },
  { feature: 'Ölçek', verge: '2 – 200 Düğüm', nutanix: '3 – 64 Düğüm', vmware: '3 – 64 Düğüm' },
  { feature: 'Tekilleştirme', verge: 'Global satır içi yerel ve uzak site çoğaltma için, Gün 1', nutanix: 'Son işlem, Eklenti, 10 yıl geç', vmware: 'Disk grubu başına, yönetmesi zor ve yetersiz' },
  { feature: 'Veri Koruması', verge: 'Sınırsız VM ve Kiracı Anlık Görüntüleri, güvenli uzak çoğaltma ile', nutanix: 'Katı donanım gereksinimleri, kiracı düzey anlık görüntü yok', vmware: 'Sınırlı VM düzeyi maks 32, kiracı düzeyi anlık görüntü yok' },
  { feature: 'Güvenli Özel Bulut', verge: 'CPU, RAM, Depolama ve Ağı kullanım başına sağla', nutanix: 'Sınırlı / Eklenti, ek destek katmanı ve maliyet', vmware: 'vCD Eklenti, ek destek katmanı ve maliyet' },
  { feature: 'Yenileme Döngüsü', verge: 'HCL Sunucu Gereksinimlerinde maksimum yaş sınırı yok', nutanix: '4 – 5 Yıl Yenileme', vmware: '4 – 5 Yıl Yenileme' },
  { feature: 'Yönetici / Küme', verge: '1 Yönetici', nutanix: '4+ Yönetici', vmware: '4+ Yönetici' },
  { feature: 'Maliyet', verge: '$$', nutanix: '$$$$$$', vmware: '$$$$$$' },
];

const hciJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'VergeOS UCI',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Any',
  description: 'HCI kısıtlamalarını aşan Ultraconverged Altyapı. Nutanix ve vSAN yerine VergeOS UCI ile 2 düğümden 200\'e ölçeklenin.',
  url: `${SITE_URL}/hci`,
};

export default function HCIPage() {
  return (
    <div className="min-h-screen w-full bg-white">
      <SEOHead
        title="HCI Alternatifi | Ultraconverged Altyapı | VergeOS"
        description="Nutanix ve vSAN yerine VergeOS UCI. HCI kısıtlamalarını aşın, gerçek birleşik altyapıyı keşfedin. 2 düğümden 200'e ölçeklenin, %80 daha az maliyet."
        keywords="HCI alternatifi, Nutanix alternatifi, vSAN alternatifi, ultraconverged, VergeOS, UCI, hyperconverged"
        canonicalPath="/hci"
        jsonLd={hciJsonLd}
      />
      <AnnouncementBar />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative w-full overflow-hidden bg-[#0f1117] py-24 text-center">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'repeating-linear-gradient(45deg,#e8600a 0,#e8600a 1px,transparent 0,transparent 50%)', backgroundSize: '20px 20px' }} />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0f1117]/60 to-[#0f1117]/90" />
          <div className="relative z-10 max-w-4xl mx-auto px-6">
            <div className="inline-block bg-[#e8600a]/20 text-[#e8600a] text-xs font-semibold uppercase tracking-widest px-4 py-1.5 rounded-full mb-6">BT Girişimleri</div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 leading-tight">
              Yeni Nesil Hiper-Yakınsak Altyapı:<br /><span className="text-[#e8600a]">Ultraconverged</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">HCI kısayollarını aşın. Gerçek birleşik altyapıyı keşfedin.</p>
          </div>
        </section>

        {/* HCI Shortcomings */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div>
                <h2 className="text-3xl font-bold text-[#1e293b] mb-4">HCI Eksiklikleri</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">BT plancıları, Nutanix ve vSAN gibi hiper-yakınsak altyapıların (HCI) BT maliyetlerini ve karmaşıklığını düşüreceğini ummaktadır. Ancak HCI eksiklikleri genellikle bu seçenekleri gözden düşürmektedir:</p>
                <ul className="space-y-3">
                  {hciShortcomings.map(item => (
                    <li key={item} className="flex items-start gap-2 text-sm text-gray-700">
                      <i className="ri-close-circle-line text-red-400 text-base shrink-0 mt-0.5"></i>{item}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://public.readdy.ai/ai/img_res/9a7a67208cae4a845eb69c9fed46fdd5.jpg" alt="HCI Karşılaştırması" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* UCI Solution */}
        <section className="py-20 bg-[#f8fafc]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-[#1e293b] mb-4">HCI Eksikliklerini Ultraconverged Altyapı (UCI) ile Ortadan Kaldırın</h2>
              <p className="text-gray-600 max-w-2xl mx-auto text-sm">VergeOS, sanallaştırma, depolama ve ağı tek bir yazılım tanımlı platformda birleştirir; HCI\'nın tüm vaatlerini karmaşıklığı olmadan yerine getirir.</p>
            </div>
            <div className="grid md:grid-cols-2 gap-16 items-center">
              <div className="grid grid-cols-1 gap-4">
                {uciAdvantages.map(u => (
                  <div key={u.title} className="flex gap-4 bg-white rounded-lg p-5 border border-gray-100">
                    <span className="w-8 h-8 flex items-center justify-center bg-[#e8600a]/10 rounded-lg text-[#e8600a] shrink-0"><i className={`${u.icon} text-base`}></i></span>
                    <div>
                      <p className="font-semibold text-[#1e293b] text-sm mb-0.5">{u.title}</p>
                      <p className="text-xs text-gray-600">{u.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="rounded-xl overflow-hidden">
                <img src="https://readdy.ai/api/search-image?query=VergeOS%20UCI%20ultraconverged%20infrastructure%20architecture%20diagram%20showing%20collapse%20of%20stack%20from%20compute%20network%20storage%20to%20single%20unified%20VergeOS%20layer%2C%20dramatic%20cost%20reduction%20visualization%2C%20orange%20and%20dark%20blue%20color%20scheme%20professional%20enterprise%20technology&width=580&height=480&seq=hci_uci1&orientation=landscape" alt="UCI Mimarisi" className="w-full h-full object-top" />
              </div>
            </div>
          </div>
        </section>

        {/* Comparison Table */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-[#1e293b] text-center mb-12">VergeOS UCI ile Diğerlerinin Karşılaştırması</h2>
            <div className="overflow-x-auto rounded-lg border border-gray-200">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-[#0f1117]">
                    <th className="px-4 py-3 text-left text-gray-400 font-semibold">Özellik</th>
                    <th className="px-4 py-3 text-left text-[#e8600a] font-semibold">VergeOS</th>
                    <th className="px-4 py-3 text-left text-gray-300 font-semibold">Diğer 1</th>
                    <th className="px-4 py-3 text-left text-gray-300 font-semibold">Diğer 2</th>
                  </tr>
                </thead>
                <tbody>
                  {comparisonRows.map((row, i) => (
                    <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                      <td className="px-4 py-3 font-medium text-[#1e293b] whitespace-nowrap">{row.feature}</td>
                      <td className="px-4 py-3 text-[#1e293b] font-medium">{row.verge}</td>
                      <td className="px-4 py-3 text-gray-500">{row.nutanix}</td>
                      <td className="px-4 py-3 text-gray-500">{row.vmware}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

      </main>
      <FooterSection />
    </div>
  );
}
